//@ts-nocheck
"use client";

import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import personalDefination from "./../assets/HomePage/Comparison/c1.jpeg";
import businessDefination from "./../assets/HomePage/Comparison/b1.png";
import p2 from "./../assets/HomePage/Comparison/p2.jpeg";
import c2 from "./../assets/HomePage/Comparison/c2.png";
import p3 from "./../assets/HomePage/Comparison/p3.png";
import c3 from "./../assets/HomePage/Comparison/c3.png";
import b4 from "./../assets/HomePage/Comparison/b4.jpeg";
import c4 from "./../assets/HomePage/Comparison/c4.jpeg";
import p5 from "./../assets/HomePage/Comparison/p5.png";
import c5 from "./../assets/HomePage/Comparison/b5.png";
import c6 from "./../assets/HomePage/Comparison/c6.png";
import p6 from "./../assets/HomePage/Comparison/b6.png";
import ActionBtn from "../components/Button/ActionBtn";

const Button = ({ children, className, ...props }) => (
  <button
    className={`
      bg-black hover:bg-black/90
      text-white font-medium
      px-6 py-2 text-sm rounded-lg
      inline-flex items-center justify-center
      transform transition-all duration-200
      hover:scale-105 hover:shadow-lg hover:shadow-blue-500/25
      ${className}
    `}
    {...props}
  >
    {children}
  </button>
);

const Modal = ({ isOpen, onClose, title, pdfs }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      {/* Modal container */}
      <div className="bg-black w-full max-w-5xl rounded-lg shadow-lg p-4 sm:p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg sm:text-xl font-bold text-white">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-300 text-lg font-bold"
          >
            ✕
          </button>
        </div>

        {/* PDF previews */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {pdfs.map((pdf, index) => (
            <div key={index} className="space-y-4">
              <iframe
                src={pdf}
                className="w-full h-64 sm:h-[500px] border rounded"
                title={`PDF ${index + 1}`}
              ></iframe>
              <a
                href={pdf}
                download={`Report-${index + 1}`}
                className="block bg-blue-500 text-white text-center py-2 rounded hover:bg-blue-600 text-sm sm:text-base"
              >
                Download Report {index + 1}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

//@ts-nocheck
const ComparisonItem = ({
  title,
  personal,
  business,
  personalImage,
  businessImage,
  onShowPersonalModal,
  onShowBusinessModal,
}) => (
  <div className="mb-16 bg-indigo-900/30 rounded-xl p-6 shadow-lg">
    <h3 className="text-2xl font-bold text-blue-300 mb-6 text-center">
      {title}
    </h3>
    <div className="grid md:grid-cols-2 gap-8">
      {/* Personal Credit Block */}
      <div className="space-y-4 text-center">
        <div className="bg-black/30 rounded-lg p-4 aspect-video flex items-center justify-center overflow-hidden">
          <img
            src={personalImage}
            alt={`Personal Credit - ${title}`}
            className="w-full h-full object-cover rounded"
          />
        </div>
        <h4 className="text-xl font-semibold text-blue-200">Personal Credit</h4>
        <p className="text-gray-300">{personal}</p>
        {title === "Scoring System" && (
          <Button className="mt-5" onClick={onShowPersonalModal}>
            See Personal Credit Report Samples
          </Button>
        )}
      </div>

      {/* Business Credit Block */}
      <div className="space-y-4 text-center">
        <div className="bg-black/30 rounded-lg p-4 aspect-video flex items-center justify-center overflow-hidden">
          <img
            src={businessImage}
            alt={`Business Credit - ${title}`}
            className="w-full h-full object-cover rounded"
          />
        </div>
        <h4 className="text-xl font-semibold text-blue-200">Business Credit</h4>
        <p className="text-gray-300">{business}</p>
        {title === "Scoring System" && (
          <Button className="mt-4" onClick={onShowBusinessModal}>
            See Business Credit Report Samples
          </Button>
        )}
      </div>
    </div>
  </div>
);

export default function CreditComparisonDetail() {
  const [isPersonalModalOpen, setIsPersonalModalOpen] = useState(false);
  const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);

  const comparisons = [
    {
      title: "Definition",
      personal:
        "Reflects an individual's creditworthiness based on their financial behavior (e.g., paying credit cards, loans).",
      business:
        "Measures a business's ability to meet its financial obligations, impacting loans, supplier terms, and more.",
      personalImage: personalDefination,
      businessImage: businessDefination,
    },
    {
      title: "Who Tracks It?",
      personal: "Consumer credit bureaus like Experian, Equifax, and TransUnion.",
      business: "Commercial credit bureaus like Experian Business, Equifax Commercial.",
      personalImage: p2,
      businessImage: c2,
    },
    {
      title: "Scoring System",
      personal: "FICO Score & VantageScore.",
      business:
        "Experian Intelliscore Plus, Equifax OneScore & Equifax PayNet MasterScore.",
      personalImage: p3,
      businessImage: c3,
    },
    {
      title: "Key Use Cases",
      personal:
        "Used for applying for credit cards, auto loans, mortgages, or renting an apartment.",
      business:
        "Used for securing business loans, vendor credit, commercial leases, and insurance rates.",
      personalImage: c4,
      businessImage: b4,
    },
    {
      title: "Impacts",
      personal: "Your score affects only your personal finances.",
      business:
        "Your score impacts your business's ability to grow, expand, and operate effectively.",
      personalImage: p5,
      businessImage: c5,
    },
    {
      title: "Visibility",
      personal:
        "Easily accessible through apps like Credit Karma, Chase Credit Journey, or Wells Fargo Credit Close-Up.",
      business: "Difficult to monitor without specialized tools like FuteurAI.",
      personalImage: c6,
      businessImage: p6,
    },
  ];

  return (
    <div
      className="
        min-h-screen
        bg-gradient-to-b
        from-black
        via-indigo-900
        to-indigo-1000
        text-white
        py-16
        px-4
        sm:px-6
        md:px-8
        lg:px-12
      "
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <Button className="mb-8" onClick={() => window.history.back()}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Back
          </Button>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Understanding the Differences:
          </h1>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-300">
            Personal vs Business Credit
          </h2>
        </div>

        {/* Comparison Items */}
        {comparisons.map((item, index) => (
          <ComparisonItem
            key={index}
            {...item}
            onShowPersonalModal={() => setIsPersonalModalOpen(true)}
            onShowBusinessModal={() => setIsBusinessModalOpen(true)}
          />
        ))}

        {/* Personal Credit Modal */}
        <Modal
          isOpen={isPersonalModalOpen}
          onClose={() => setIsPersonalModalOpen(false)}
          title="Personal Credit Report Samples"
          pdfs={["/pdfs/EquifaxPersonalSample.pdf", "/pdfs/experianSampleReport.pdf"]}
        />

        {/* Business Credit Modal */}
        <Modal
          isOpen={isBusinessModalOpen}
          onClose={() => setIsBusinessModalOpen(false)}
          title="Business Credit Report Samples"
          pdfs={["/pdfs/paynet.pdf", "/pdfs/experian.pdf"]}
        />
        <div className="flex justify-center">
         <ActionBtn variant={2} link="https://app.futeur.ai/signup" title="Start Monitoring Now" />
         </div>
      </div>
    </div>
  );
}

